<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">{{tipodimension}}</h4>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label class="pull-left" for="usr">Acciones de Mejoramiento</label>
              <select class="form-control" id="5" v-model="actividad" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(actividad,index) in actividades"
                  :key="index"
                  :value="actividad"
                >{{actividad.actividadTexto}}</option>
              </select>
            </v-flex>
          </v-layout>
          <br />

          <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
            <v-layout>
              <v-flex md12 lg12 xs12 sm12 xl12>
                <table class="table table-striped header-fixed">
                  <thead>
                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                      >Nombre de Acción</th>
                      <th
                        style="text-align: left"
                        class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                      >{{actividad.actividadTexto}}</th>
                    </tr>
                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                      >Debilidad</th>
                      <th
                        style="text-align: left"
                        class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                      >{{descripcion}}</th>
                    </tr>
                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                      >Objetivo Estratégico</th>
                      <th
                        style="text-align: left"
                        class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                      >{{actividad.objetivo}}</th>
                    </tr>

                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                      >Estrategia</th>
                      <th
                        style="text-align: left"
                        class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                      >{{actividad.estrategia}}</th>
                    </tr>

                    <tr>
                      <th
                        style="text-align: center"
                        :class="header.border"
                        v-for="(header,index) in headers"
                        :key="index"
                      >{{header.text}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in hitos" :key="index">
                      <td style="text-align:left " :class="headers[0].size">{{item.nombre}}</td>
                      <td style="text-align:left " :class="headers[1].size">{{item.responsable}}</td>
                      <td style="text-align:left " :class="headers[2].size">{{item.indicador}}</td>
                      <td
                        style="text-align:left "
                        :class="headers[3].size"
                      >{{formatDate(item.plazoCumplimiento)}}</td>
                      <td :class="headers[4].size">
                        <v-icon
                          :disabled="($session.getAll().puedeEditar == false) "
                          small
                          class="mr-2"
                          @click="openeditHito(item,index)"
                        >edit</v-icon>
                        <v-icon
                          v-if="!item.aprobado && $session.getAll().puedeEditar == true"
                          small
                          color="green"
                          @click="openCheckPlan(item,index)"
                        >check</v-icon>
                        <v-icon
                          v-if="!item.aprobadoPlan && $session.getAll().puedeEditar == true"
                          small
                          @click="deleteActividad(item)"
                        >delete</v-icon>
                      </td>
                      <td :class="headers[5].size">
                        <v-icon small class="mr-2" @click="viewDocument(item)">add</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout justify-start row fill-height class="margin-button">
            <v-flex md12 lg12 xs8 sm8>
              <v-btn color="#394049" @click="opencreateHito">Agregar Indicador</v-btn>
              <v-btn
                color="#394049"
                v-if="this.$session.getAll().userType == 'postgradodca'"
                @click="comentario = true"
              >Comentario</v-btn>

              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                @click="openAprobacion"
              >Aprobación DCA</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType != 'postgradodca'"
                color="#394049"
                @click="openViewAprobacion()"
              >Estado de aprobación DCA</v-btn>

              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="#394049"
                @click="openAprobacionPost"
              >Aprobación Programa</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType != 'postgrado'"
                color="#394049"
                @click="openViewAprobacionPost()"
              >Estado de aprobación Programa</v-btn>

              <v-btn color="#394049"  dark  @click="video = true">
                <v-icon dark>video_library</v-icon>
              </v-btn>
            </v-flex>

            <!-- <v-flex md2 lg2 xs2 sm2>
              <img :src="img3" class="image" @click="asistencia = true" />
            </v-flex> -->
          </v-layout>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-dialog v-model="asistencia" width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card class="v-card-dialog">
              <v-card-title>
                <span class="headline">Asistencia DCA</span>
              </v-card-title>
              <div class="form-group">
                <label for="comment">Comenta tus inquietudes</label>
                <textarea class="form-control" rows="9" id="comment"></textarea>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#ec6a12" flat="flat" @click="asistencia = false">Cerrar</v-btn>
                <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="confirm" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-auto">
            <v-card-title>
              <span class="headline">¿Desea aprobar el indicador?</span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="confirm = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" @click="checkPlan()">aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="comentario" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-auto">
            <v-card-title>
              <span class="headline">Comentario de Acción</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="comment">Comentario</label>
                <textarea
                  v-model="actividad.estadoAprobacion"
                  rows="9"
                  class="form-control"
                  id="comment"
                />
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="comentario = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" @click="updateComentario()">Enviar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px" persistent>
        <v-card class="v-card-dialog">
          <v-card-title>
            <span class="headline" v-if="!create">Editar indicador</span>
            <span class="headline" v-if="create">Crear indicador</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12 v-if="create">
                <label for="usr">Accción de Mejoramiento</label>
                <select
                  :disabled="true"
                  class="form-control"
                  id="5"
                  v-model="actividad"
                  place-holder="asddsa"
                >
                  <option value selected disabled>-Selecciona una opción-</option>
                  <option
                    v-for="(actividad,index) in actividades"
                    :key="index"
                    :value="actividad"
                  >{{actividad.actividadTexto}}</option>
                </select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre del indicador</label>
                <textarea
                  :disabled="hito.aprobado"
                  v-model="hito.nombre"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Responsable</label>
                <textarea
                  :disabled="hito.aprobado"
                  v-model="hito.responsable"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Recursos Utilizados</label>
                <textarea
                  :disabled="hito.aprobado"
                  v-model="hito.indicador"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :disabled="hito.aprobado"
                      v-model="computedDateFormatted"
                      label="Plazo de cumplimiento"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :disabled="hito.aprobado"
                    locale="es-ES"
                    :first-day-of-week="1"
                    v-model="hito.plazoCumplimiento"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editHito()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createHito()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacion" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa4Dca">Aprobado por DCA</h4>
                <h4 v-if="!this.etapa.etapa4Dca">Aún no hay aprobación por parte de DCA</h4>
                <h4>{{etapa["fechaEtapa"+nEtapa]}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapa"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgradodca'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacion = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="red"
                flat="flat"
                @click="checkPro(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                flat="flat"
                @click="checkPro(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionPost" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa4Otro">Aprobado por Programa</h4>
                <h4 v-if="!this.etapa.etapa4Otro">Aún no hay aprobación por parte del programa</h4>
                <h4>{{etapa["fechaEtapa"+nEtapa+"Gral"]}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaPost"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgrado'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="aprobacionPost = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="red"
                flat="flat"
                @click="checkPrograma(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="#394049"
                flat="flat"
                @click="checkPrograma(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-dialog v-model="eliminar" width="500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline">¿Está seguro de querer eliminar el indicador {{act.nombre}}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
          <v-btn color="#394049" flat="flat" @click="erase(act.id)">Sí, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-dialog v-model="video" width="1000">
        <template v-slot:activator="{ on }"></template>
        <v-toolbar dark color="#eb7704">
          <v-btn icon dark @click="pauseVideo()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="v-card-dialog">
          <video controls id="myVideo">
            <source :src="video1" type="video/mp4" />
          </video>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_7.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
import video1 from "../../../assets/video4.mp4";

export default {
  data() {
    return {
      video: "",
      video1: video1,
      eliminar: false,
      comentario: false,
      act: {},
      descripcion: "",
      menu1: false,
      menu2: false,
      actividades: "",
      actividad: "",
      step1: true,
      tipodimension: " ",
      hitos: "",
      img3: img3,
      estrategia: "",
      asistencia: false,
      debilidades: [
        "Falta promoción de integración de estudiantes USACH con sus pares de otras universidades en campus clínicos."
      ],
      create: false,
      nEtapa: 4,
      etapa: "",
      obsEtapa: "",
      aprobacion: "",
      obsEtapaPost: "",
      aprobacionPost: "",
      edit: false,
      index: "",
      dialog: false,
      hito: {},
      headers: [
        {
          text: "Indicador",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Responsable",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Recursos utilizados",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Plazo",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Docs",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],
      headers2: [
        {
          text: "",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text: "Últimos años de cumplimiento",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      confirm: false,
      right: null
    };
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.hito.plazoCumplimiento);
    }
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    actividad: function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    this.hito = 0;
    this.tipodimension = "Definición de indicadores y aprobación";
    var apipath = "/actividad/getAll?idCarrera=";
    //console.log(this.$session.getAll().ccData.id);
    axios
      .get(process.env.ROOT_API + apipath + this.$session.getAll().ccData.id, {
        headers: { Authorization: "" + this.$session.get("jwt") }
      })
      .then(response => {
        //console.log("actividades");
        //console.log(response.data);
        this.actividades = response.data;
        this.actividad = this.actividades[0];
        this.descripcion = this.actividad.debilidad.descripcion;
      })
      .catch(error => {
        console.error(error);
      });
    this.initObservacionGral();
  },

  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    deleteActividad(item) {
      this.act = item;
      this.eliminar = true;
    },
    erase(id) {
      axios
        .delete(process.env.ROOT_API + "/hito/delete?idHito=" + id, this.auth)
        .then(response => {
          this.eliminar = false;
          alert(response.data);
          this.initComponent();
        })
        .catch(error => {
          alert(error.response.data);
        });
    },
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    initComponent() {
      var apipath = "/hito/getAll?idActividad=";
      //console.log(this.actividad);
      this.descripcion = this.actividad.debilidad.descripcion;
      if (this.actividad == null) {
        alert("No existen acciones de momento, no puede crear indicadores.");
      } else {
        axios
          .get(process.env.ROOT_API + apipath + this.actividad.id, {
            headers: { Authorization: "" + this.$session.get("jwt") }
          })
          .then(response => {
            //console.log("actividades");
            //console.log(response.data);
            this.hitos = response.data;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },

    checkPrograma(booleanValue) {
      this.aprobacionPost = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaPost;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    checkPro(booleanValue) {
      this.aprobacion = false;
      this.etapa["comentarioEtapa" + this.nEtapa] = this.obsEtapa;
      this.etapa["etapa" + this.nEtapa + "Dca"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaDca?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa " + this.nEtapa + " ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    viewDocument(item) {
      this.$router.push({ name: "indicadoresDoc", params: { id: item.id } });
    },

    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
          this.obsEtapaPost =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.etapa = response.data;
          //console.log(this.obsEtapa);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          "http://localhost:8089/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    openeditHito(hito, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.hito = hito;
    },

    openAprobacion() {
      this.aprobacion = true;
      this.create = true;
    },
    openViewAprobacion() {
      this.aprobacion = true;
      this.create = false;
    },

    openAprobacionPost() {
      this.aprobacionPost = true;
      this.create = true;
    },
    openViewAprobacionPost() {
      this.aprobacionPost = true;
      this.create = false;
    },

    openCheckPlan(hito, index) {
      this.confirm = true;
      this.index = index;
      this.hito = hito;
    },

    checkPlan() {
      this.confirm = false;
      //console.log(this.hito);
      axios
        .patch(
          process.env.ROOT_API + "/hito/updateHito?etapa=2",
          this.hito,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Acción aprobada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    opencreateHito() {
      this.create = true;
      this.edit = true;
      this.hito = {};
    },

    updateComentario() {
      const comentario = {
        comentario: this.actividad.estadoAprobacion
      };
      axios
        .patch(
          process.env.ROOT_API +
            "/actividad/updateComentarioAccion?idActividad=" +
            this.actividad.id,
          comentario,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          this.comentario = false;
          alert("Acción editada");
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    editHito() {
      this.edit = false;
      axios
        .patch(
          process.env.ROOT_API + "/hito/updateHito?etapa=1",
          this.hito,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Indicador Actualizado");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    createHito() {
      this.create = false;
      this.edit = false;
      axios
        .post(
          process.env.ROOT_API +
            "/hito/createHito?idActividad=" +
            this.actividad.id,
          this.hito,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Indicador creado");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },

    cambio1() {
      this.step1 = true;
    },
    cambio2() {
      this.step1 = false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    pauseVideo() {
      document.getElementById("myVideo").pause();
      this.video = false;
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

.v-card-dialog {
  height: auto !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/mejoramiento/DefinicionIndicadores.vue